// src/custom-fields-display.ts
import { isNotEmpty } from "@vy/array";
var CUSTOM_FIELD_PREFIX = "customField_";
var CUSTOMER_PREFIX = "customer_";
var CONTRACT_PREFIX = "contract_";
var CUSTOM_FIELD_ENTITY_PREFIXES = [CUSTOMER_PREFIX, CONTRACT_PREFIX];
function hasEntityPrefix(field) {
  return CUSTOM_FIELD_ENTITY_PREFIXES.some((prefix) => field.startsWith(prefix));
}
function removeEntityPrefix(field) {
  for (const prefix of CUSTOM_FIELD_ENTITY_PREFIXES) {
    if (field.startsWith(prefix)) {
      return field.slice(prefix.length);
    }
  }
  return field;
}
function hasConfigPrefix(field) {
  return field.startsWith(CUSTOM_FIELD_PREFIX);
}
function removeConfigPrefix(field) {
  return field.startsWith(CUSTOM_FIELD_PREFIX) ? field.slice(CUSTOM_FIELD_PREFIX.length) : field;
}
var normalizeConfigField = removeConfigPrefix;
function getCustomFieldDisplayName(fieldName) {
  return removeEntityPrefix(fieldName);
}
function extractCustomFieldNamesFromConfig(configColumns, baseFields) {
  const configCustomNames = [];
  if (isNotEmpty(configColumns)) {
    for (const col of configColumns) {
      if (!baseFields.has(col.field) || hasConfigPrefix(col.field)) {
        configCustomNames.push(removeConfigPrefix(col.field));
      }
    }
  }
  return configCustomNames;
}
function flattenCustomFieldValuesIntoRow(item) {
  const base = { ...item };
  if (isNotEmpty(item.customFieldValues)) {
    for (const cf of item.customFieldValues) {
      if (cf.fieldName) {
        base[cf.fieldName] = cf.value;
      }
    }
  }
  return base;
}
function findCustomFieldValue(customFieldValues, columnField) {
  if (!customFieldValues) {
    return null;
  }
  const match = customFieldValues.find((c) => c.fieldName === columnField);
  return match?.value != null ? match.value : null;
}
function buildColumnVisibilityModelFromConfig(configColumns, baseFields) {
  const visibilityModel = {};
  if (isNotEmpty(configColumns)) {
    for (const col of configColumns) {
      const isCustomField = hasEntityPrefix(col.field);
      const isNotBaseField = baseFields ? !baseFields.has(col.field) : true;
      if (isCustomField || isNotBaseField) {
        visibilityModel[col.field] = col.isVisible;
      }
    }
  }
  return visibilityModel;
}
function extractCustomFieldNamesFromLocalStorageConfig(configVisibility, baseFields) {
  if (!configVisibility) {
    return [];
  }
  const customFieldNames = [];
  for (const field of Object.keys(configVisibility)) {
    const isCustomField = hasEntityPrefix(field);
    const isNotBaseField = !baseFields.has(field);
    if (isCustomField && isNotBaseField) {
      customFieldNames.push(field);
    }
  }
  return customFieldNames;
}
export {
  CONTRACT_PREFIX,
  CUSTOMER_PREFIX,
  CUSTOM_FIELD_ENTITY_PREFIXES,
  CUSTOM_FIELD_PREFIX,
  buildColumnVisibilityModelFromConfig,
  extractCustomFieldNamesFromConfig,
  extractCustomFieldNamesFromLocalStorageConfig,
  findCustomFieldValue,
  flattenCustomFieldValuesIntoRow,
  getCustomFieldDisplayName,
  hasConfigPrefix,
  hasEntityPrefix,
  normalizeConfigField,
  removeConfigPrefix,
  removeEntityPrefix
};
